import { Skeleton } from '@material-ui/lab'
import React, { FC, ReactElement } from 'react'

/**
 * Add user loader
 */
export const LoadingNotificationSkelton: FC = (): ReactElement => (
    <div className='tabs-content-loader add-user-loading'>
        <div className='tabs-menu-loaders'>
            <Skeleton variant='text' width='100%' height={40} />
            <Skeleton variant='text' width='100%' height={40} />
        </div>
        <div className='tabs-content-loaders'>
            <div className='section'>
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
            </div>
        </div>
    </div>
)
